export default "__VITE_ASSET__UKqS_K2v__"